// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xGjr","largestCol":"styles_largestCol__3Of88","smallestCol":"styles_smallestCol__2Mmtj"};